export const episodesControlsSetOpen = () => {
  return {
    type: 'EPISODES_CONTROLS_SET_OPEN'
  }
};

export const episodesControlsSetClosed = () => {
  return {
    type: 'EPISODES_CONTROLS_SET_CLOSED'
  }
};

export const episodesControlsToggle = () => {
  return {
    type: 'EPISODES_CONTROLS_TOGGLE'
  }
};

export const showSmallSpinner = () => {
  return {
    type: 'SHOW_SMALL_SPINNER'
  }
};

export const hideSmallSpinner = () => {
  return {
    type: 'HIDE_SMALL_SPINNER'
  }
};

export const setCurrentEpisodeComments = (current_episode_comments) => {
  return {
    type: 'SET_CURRENT_EPISODE_COMMENTS',
    current_episode_comments
  }
};

export const appendCurrentEpisodeComments = (comments_to_load) => {
  return {
    type: 'APPEND_CURRENT_EPISODE_COMMENTS',
    comments_to_load
  }
};

export const preppendCurrentEpisodeCommentsWithNewPoppin = (payload) => ({
  type: 'PREPPEND_CURRENT_EPISODE_COMMENTS_WITH_NEW_POPPIN',
  payload
});

export const cutRepliesFor = (commented_id, commented_type) => {
  return {
    type: 'CUT_REPLIES_FOR',
    commented_id,
    commented_type,
  }
};

export const setRepliesFor = (commented_id, commented_type, replies, cutted) => {
  return {
    type: 'SET_REPLIES_FOR',
    commented_id,
    commented_type,
    replies,
    cutted
  }
};

export const openReplyForm = (parent_id, parent_type) => {
  return {
    type: 'OPEN_REPLY_FORM',
    parent_id,
    parent_type
  }
};

export const closeReplyForm = () => {
  return {
    type: 'CLOSE_REPLY_FORM'
  }
};

export const setReplyFormBody = (body) => {
  return {
    type: 'SET_REPLY_FORM_BODY',
    body
  }
};

export const removePopComment = optionsMenu => ({
  type: 'REMOVE_POP_COMMENT',
  optionsMenu
});

export const updatePopCommentOrReply = (update_form) => {
  return {
    type: 'UPDATE_POP_COMMENT_OR_REPLY',
    ...update_form
  }
};

export const openUpdateForm = (update_form) => {
  return {
    type: 'OPEN_UPDATE_FORM',
    ...update_form
  }
};

export const closeUpdateForm = () => {
  return {
    type: 'CLOSE_UPDATE_FORM'
  }
};

export const setUpdateFormBody = (body) => {
  return {
    type: 'SET_UPDATE_FORM_BODY',
    body
  }
};

export const addReplyFor = (commented_id, commented_type, reply) => {
  return {
    type: 'ADD_REPLY_FOR',
    commented_id,
    commented_type,
    reply
  }
};

export const setReactionFor = (commented_id, commented_type, reaction) => {
  return {
    type: 'SET_REACTION_FOR',
    commented_id: commented_id,
    commented_type: commented_type,
    reaction: reaction
  }
};

